import React, { useEffect, useState } from "react";
import { toolsAPI } from "../../../utils/funcionesAPI";
import { withRouter } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { manejadorDeRespuesta } from "../../../utils/Tools";
import PropTypes from "prop-types";
import SelectorDireccionesFactura from "../../Global/SelectorDireccionesFactura";

const DatosFacturacionMiPerfil = (props) => {
  const formularioDefault = {
    id: 0,
    responsabilidad: "",
    tipoDocumento: { sigla: "" },
    numeroDocumento: "",
    factura: "",
    razonSocial: "",
    calle: "",
    altura: "",
    codigoPostal: "",
    mail: "",
    provincia: { id: 2, codigo: "ARC", denominacion: "Capital Federal" },
    localidad: { id: "5001", denominacion: "Ciudad Autónoma De Buenos Aires" },
    numeroReserva: props.numeroReserva,
    esPropia: 0,
  };
  const [tiposDocumento, setTiposDeDocumento] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [categoriasIVA, setCategoriasIva] = useState([]);
  const [formulario, setFormulario] = useState(formularioDefault);
  const [deshabilitarTipoDocumento, setDeshabilitarTipoDocumento] =
    useState(true);
  const [deshabilitarFactura, setDeshabilitarFactura] = useState(true);
  const [formularioSeleccionado, setFormularioSeleccionado] = useState({
    id: 0,
    provincia: { id: 2, codigo: "ARC", denominacion: "Capital Federal" },
  });

  const { usuario } = props;

  const getLocalidadesPorProvincia = (codigoProvincia) => {
    const data = JSON.stringify({ accion: "localidades", codigoProvincia });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setLocalidades(respuesta.data);
    });
  };

  useEffect(() => {
    let data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDeDocumento(respuesta.data);
    });

    data = JSON.stringify({ accion: "provincias" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) setProvincias(respuesta.data);
    });

    data = JSON.stringify({ accion: "categoriasIVA" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setCategoriasIva(respuesta.data);
    });

    //getLocalidadesPorProvincia("ARC");
  }, []);

  useEffect(() => {
    const provinciaEncontrado = searchProvinciaFromId(
      formularioSeleccionado.provincia.id
    );
    getLocalidadesPorProvincia(provinciaEncontrado.codigo);
  }, [formularioSeleccionado.provincia]);

  const handleTipoDocumentoChange = (e) => {
    const sigla = e.target.value;
    const tipoDocumentoEncontrado = tiposDocumento.find(
      (e) => e.sigla === sigla
    );
    let formularioClone = Object.assign({}, formulario);
    formularioClone.tipoDocumento = tipoDocumentoEncontrado;
    setFormulario(formularioClone);
  };

  const searchProvinciaFromId = (id) => {
    const provinciaEncontrado = provincias.find((e) => e.id === id);
    const provinciaEncontradoResult = provinciaEncontrado || { codigo: 0 };
    return provinciaEncontradoResult;
  };

  const handleProvinciaChange = (e) => {
    //const codigoProv = e.target.value;
    //const idProv = e.target.value;
    //const provinciaEncontrado = provincias.find((e) => e.codigo === codigoProv);
    //const provinciaEncontrado = provincias.find((e) => e.id === idProv);
    let formularioClone = Object.assign({}, formulario);
    formularioClone.localidad = { id: 0 };
    formularioClone.provincia = searchProvinciaFromId(e.target.value);
    setFormulario(formularioClone);
    getLocalidadesPorProvincia(formularioClone.provincia.codigo);
  };

  const handleLocalidadChange = (e) => {
    const idLocalidad = e.target.value;
    const localidadEncontrada = localidades.find((e) => e.id === idLocalidad);
    let formularioClone = Object.assign({}, formulario);
    formularioClone.localidad = localidadEncontrada || { id: 0 };
    setFormulario(formularioClone);
  };

  const handleActualizarDatosFacturacionClick = (e) => {
    e.preventDefault();

    if (
      formulario.razonSocial === "" ||
      !formulario.calle ||
      formulario.calle === "" ||
      formulario.altura === "" ||
      !formulario.altura ||
      formulario.codigoPostal === "" ||
      !formulario.codigoPostal ||
      formulario.provincia.id === 0 ||
      formulario.provincia.id === "" ||
      formulario.localidad.id === 0 ||
      formulario.localidad.id === "" ||
      formulario.numeroDocumento === "" ||
      formulario.factura === "" ||
      formulario.tipoDocumento.sigla === "" ||
      formulario.responsabilidad === "" ||
      formulario.responsabilidad === "0" ||
      formulario.id === "0"
    ) {
      toast.info("Debe completar todos los campos", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return false;
    }
    if (formulario.calle && formulario.calle.length < 5) {
      toast.info("La calle debe tener al menos 5 caracteres", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return false;
    }

    props.onActualizarDatosFacturacionClick(formulario);
  };

  const handleEliminarDatosFacturacionClick = (e) => {
    e.preventDefault();
    props.onEliminarDatosFacturacionClick(formulario.id);
  };

  const handelChangeFormulario = (e) => {
    //console.log(e.target.value);
    let formularioClone = Object.assign({}, formulario);
    formularioClone[e.target.name] = e.target.value;
    //FC: si es tipo de cliente valido los tipo de documento permitidos
    let deshabilitarTipoDocumentoClone = deshabilitarTipoDocumento;
    let deshabilitarFacturaClone = deshabilitarFactura;

    if (e.target.name === "numeroDocumento") { 
      if (!/^\d*$/.test(e.target.value)) {
        return;
      }
    }

    if (e.target.name === "responsabilidad") {
      if (e.target.value === "CFI") {
        formularioClone.tipoDocumento = { sigla: "DNI" };
        deshabilitarTipoDocumentoClone = true;
        deshabilitarFacturaClone = false;
        formularioClone.factura = "FACB";
      } else if (e.target.value === "MON") {
        formularioClone.tipoDocumento = { sigla: "CUIT" };
        deshabilitarTipoDocumentoClone = true;
        deshabilitarFacturaClone = false;
        formularioClone.factura = "FACB";
      } else {
        deshabilitarTipoDocumentoClone = true;
        formularioClone.tipoDocumento = { sigla: "CUIT" };
        if (e.target.value === "RIN") {
          formularioClone.factura = "FACA";
          deshabilitarFacturaClone = true;
        } else {
          deshabilitarFacturaClone = false;
        }
      }
    }

    setFormulario(formularioClone);
    setDeshabilitarFactura(deshabilitarFacturaClone);
    setDeshabilitarTipoDocumento(deshabilitarTipoDocumentoClone);
  };

  return (
    <div className="row col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 form">
      <h2 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        datos de facturacion
      </h2>
      <SelectorDireccionesFactura
        formularioDefault={formularioDefault}
        formularioSeleccionado={formularioSeleccionado}
        setFormularioSeleccionado={setFormularioSeleccionado}
        setFormulario={setFormulario}
        handleProvinciaChange={handleProvinciaChange}
      />
      <form
        id="solicitarFactura"
        action="#"
        method="post"
        className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row"
      >
        <label
          style={{ marginTop: "5px" }}
          className="labelPerfil  text-left"
          htmlFor="responsabilidad"
        >
          Categoria
        </label>
        <div className="input-group">
          <select
            name="responsabilidad"
            className="custom-select"
            value={formulario.responsabilidad}
            onChange={handelChangeFormulario}
          >
            <option value="0">Seleccione una categoria</option>
            <option value="RIN">Responsable Inscripto</option>
            <option value="MON">Monotributo</option>
            <option value="EXE">Exento</option>
            <option value="CFI">Consumidor Final</option>
          </select>
        </div>

        <label
          style={{ marginTop: "5px" }}
          className="labelPerfil text-left"
          htmlFor="tipoDocumento"
        >
          Tipo Documento
        </label>
        <div className="input-group">
          <select
            name="tipoDocumento"
            className="custom-select"
            onChange={handleTipoDocumentoChange}
            disabled={deshabilitarTipoDocumento}
            value={formulario.tipoDocumento.sigla}
          >
            <option value="0">Seleccione un documento</option>
            {tiposDocumento.map((tipoDeDocumento) => {
              return (
                <option
                  key={tipoDeDocumento.idTipoDocumento}
                  value={tipoDeDocumento.sigla}
                >
                  {tipoDeDocumento.denominacion}
                </option>
              );
            })}
          </select>
        </div>

        <label
          style={{ marginTop: "5px" }}
          className="labelPerfil  text-left"
          htmlFor="responsabilidad"
        >
          Responsabilidad
        </label>
        <div className="input-group">
          <select
            name="factura"
            className="custom-select"
            value={formulario.factura}
            disabled={deshabilitarFactura}
            onChange={handelChangeFormulario}
          >
            {formulario.responsabilidad === "CFI" ||
            formulario.responsabilidad === "MON" ? null : (
              <option value="FACA">Factura A</option>
            )}
            <option value="FACB">Factura B</option>
          </select>
        </div>

        <div
          className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
          style={{ padding: "0" }}
        >
          <label
            style={{ marginTop: "5px" }}
            className="labelPerfil text-left"
            htmlFor="numeroDocumento"
          >
            {formulario.tipoDocumento.sigla !== "CUIT"
              ? "N° Documento"
              : "CUIT/CUIL (sin guiones)"}
          </label>
          <input
            value={formulario.numeroDocumento}
            name="numeroDocumento"
            placeholder="Número"
            type="text"
            className="form-control"
            onChange={handelChangeFormulario}
          />
        </div>

        <div className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label
            style={{ marginTop: "5px" }}
            className="labelPerfil text-left"
            htmlFor="razonSocial"
          >
            Nombre y Apellido Completo / Razon Social
          </label>
          <input
            type="text"
            value={formulario.razonSocial}
            name="razonSocial"
            placeholder="Nombre completo / Razon Social"
            className="form-control"
            onChange={handelChangeFormulario}
          />
        </div>

        <div
          className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
          style={{ padding: "0" }}
        >
          <label
            style={{ marginTop: "5px" }}
            className="labelPerfil text-left "
            htmlFor="calle"
          >
            Calle
          </label>
          <input
            value={formulario.calle}
            name="calle"
            placeholder="Calle"
            type="text"
            className="form-control"
            onChange={handelChangeFormulario}
          />
        </div>

        <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <label
            style={{ marginTop: "5px" }}
            className="labelPerfil text-left "
            htmlFor="altura"
          >
            Altura
          </label>
          <input
            value={formulario.altura}
            name="altura"
            placeholder="Numero"
            type="text"
            className="form-control"
            onChange={handelChangeFormulario}
          />
        </div>

        <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <label
            style={{ marginTop: "5px" }}
            className="labelPerfil text-left "
            htmlFor="codigoPostal"
          >
            Cod. Postal
          </label>
          <input
            value={formulario.codigoPostal}
            name="codigoPostal"
            placeholder="C.P."
            type="text"
            className="form-control"
            onChange={handelChangeFormulario}
          />
        </div>

        <div
          className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
          style={{ padding: "0" }}
        >
          <label className="labelPerfil text-left " htmlFor="provincia">
            Provincia *
          </label>
          <select
            className="form-control"
            name="provincia"
            onChange={handleProvinciaChange}
            value={formulario.provincia.id}
          >
            <option value="0">Provincia</option>
            {provincias.map((provincia) => {
              return (
                <option key={provincia.id} value={provincia.id}>
                  {provincia.denominacion}
                </option>
              );
            })}
          </select>
        </div>

        <div className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
          <label className="labelPerfil text-left " htmlFor="localidades">
            Localidad *
          </label>
          <select
            className="form-control"
            name="localidades"
            onChange={handleLocalidadChange}
            value={formulario.localidad.id}
          >
            <option value="0">Localidad</option>
            {localidades.map((localidad) => {
              return (
                <option key={localidad.id} value={localidad.id}>
                  {localidad.denominacion}
                </option>
              );
            })}
          </select>
        </div>
        <div
          className="form-group d-inline-block col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          style={{ padding: "0" }}
        >
          <label
            style={{ marginTop: "5px" }}
            className="labelPerfil text-left "
            htmlFor="codigoPostal"
          >
            Email
          </label>
          <input
            value={formulario.mail}
            name="mail"
            placeholder="Email"
            type="text"
            className="form-control"
            onChange={handelChangeFormulario}
          />
        </div>
        <div
          className="form-group d-inline-block col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          style={{ padding: "0" }}
        >
          <div className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <input
              type="submit"
              className="boton"
              value="Eliminar Datos"
              onClick={handleEliminarDatosFacturacionClick}
            />
          </div>

          <div className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <input
              type="submit"
              className="botonInicio"
              value="Guardar Cambios"
              onClick={handleActualizarDatosFacturacionClick}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default withRouter(DatosFacturacionMiPerfil);



// WEBPACK FOOTER //
// ./src/components/MiPerfil/DatosFacturacionMiPerfil/index.js